import { ValidatorFn, AbstractControl } from '@angular/forms';

export const nonZeroIntegerValidator: ValidatorFn = (control: AbstractControl) => {
    const rawValue = control.value;
    if (rawValue === null || rawValue === undefined || rawValue === '') {
        return null; 
    }
    const num = typeof rawValue === 'number' ? rawValue : Number(rawValue);
    if (!Number.isFinite(num) || !Number.isInteger(num) || num === 0) {
        return { nonZeroInteger: true };
    }
    return null;
}
